//
import {queryList, saveObject, updateObject,getResetPermission, getDeleteRole, getPageOpsByRoleAndMenu, getMenuPageOpList,getExportRoleData} from './../api';
import { Message } from 'element-ui';
//
const role = {
    namespaced: true,
    state: {
        successCode:200,
        resp:null,
        allPowerPermission:null,
        powerPermission:null,
        addResp:null,
        updateResp:null,
        deleteRole:null,
        pageOpRoleMenu:null,
        pageOpList:null,
        total:null,
        handleData:null,
        exportRoleData:null,
    },
    mutations: {
      QUERY_LIST(state,resp){
          state.resp = resp.obj || [];
          state.total = resp.total
        },
      SAVE_OBJECT(state,resp){
            state.addResp = resp
        },
      UPDATE_OBJECT(state,resp){
            state.updateResp = resp
        },
      SET_DATA(state,data){
            state[data.page]=data;
        },
      GET_ALL_PERMISSION_BY_CLIENTID(state,data){
        state.allPowerPermission = data
      },
      GET_DELETE_ROLE(state,data){
        state.deleteRole = data;
      },
      GET_RESET_PERMISSION(state, data){
        state.powerPermission = data
      },
      GET_PAGE_OP_BY_ROLE_MENU(state,data){
        state.pageOpRoleMenu = data;
      },
      GET_MENU_PAGE_OP_LIST(state,data){
        let obj = {}
        let dataArray = []
        if(data.obj && data.obj.childMenus){
          obj.data = buildData(data.obj.childMenus);
          //
          obj.data.forEach(t => {
            dataArray.push(t)
          })
        }

        //
        state.pageOpList = dataArray
        const {token, code}  = data;
        state.pageOpListCode = code
      },
      HANDLE_EDIT_DATA(state, data){


        let dd = new Object()

        dd = data
        let fromData = {
          roleId:data.roleId,
          roleName:data.roleName,
          remark:data.remark,
        }

        state.handleData = fromData;

      },
      GET_EXPORT_ROLE_DATA(state,data){
        state.exportRoleData = data;
      }
    },
    actions: {
        async setData({commit},data){
            commit('SET_DATA', data);
        },
       async queryList({commit}, obj){
           let resp = await queryList(obj);
           commit('QUERY_LIST', resp);
        },
        async saveObject({commit}, obj){
            let resp = await saveObject(obj);
            commit('SAVE_OBJECT', resp);
        },
        async updateObject({commit}, obj){
            let resp = await updateObject(obj);
            commit('UPDATE_OBJECT',resp);
        },
        async getDeleteRole({commit}, obj){
          let resp = await getDeleteRole(obj);
          commit('GET_DELETE_ROLE',resp);
        },
        async getResetPermission({commit}, obj){
          let resp = await getResetPermission(obj);
          commit('GET_RESET_PERMISSION', resp);
        },
        async getPageOpsByRoleAndMenu({commit}, obj){
          let resp = await getPageOpsByRoleAndMenu(obj);
          commit('GET_PAGE_OP_BY_ROLE_MENU', resp);
        },
        async getMenuPageOpList({commit}, obj){
          let resp = await getMenuPageOpList(obj)
          commit('GET_MENU_PAGE_OP_LIST', resp);
        },
        handleEditData({commit}, data){
          commit('HANDLE_EDIT_DATA', data);
        },
        async getExportRoleData({commit}, obj){
          let resp = await getExportRoleData(obj);
          commit('GET_EXPORT_ROLE_DATA', resp);
        },
    }
}
function buildData(objList) {
  let resList = [];
  if(objList){
    objList.forEach(temp=>{
      let child = {
        id : temp.id,
        description : temp.menuNameZh,
        parentId : temp.parentId,
        selectchecked : [],
        checkAll : false,
        checked : false,
        isIndeterminate : false
      };
      if(temp.hasChild === 'Y'){
        child.type=0;
        child.act ='全选';
        child.children = buildData(temp.childMenus);
        if(child.children && child.children.length >0){
          resList.push(child)
        }
      }else {
        if (!temp.pageOpIds){
          temp.pageOpIds = []
        }
        if (!temp.permissionIds){
          temp.permissionIds = []
        }
        let ids = temp.pageOpIds;
        let ids2 = temp.permissionIds;
        ids2.forEach(o=>{
          ids.push("p_"+o);
        })
        child.selectchecked = ids;
        if(temp.pageOpList){
          temp.pageOpList.forEach(obj=>{
            if(obj.opType === 2){
              obj.pageOpId = "p_"+obj.pageOpId;
            }
          })
          child.type = 1,
          child.sonData1 = temp.pageOpList;
          resList.push(child)
        }
      }
    })
  }
  return resList;
}
export default role



// WEBPACK FOOTER //
// ./src/page/auth/role/store/role.store.js